import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddLibraryForm from "./library-forms/add-library-form";
import { getLibraryBooks, updateLibraryBookStatus, deleteLibraryBook } from "./libraryServices/libraryManagement";
import { useGlobalState } from "../../../services/hostelConst";
import AddLibraryBookForm from "./library-forms/add-book-form";


const LibraryBookTable = () => {
  const { toggleHostelMenu } = useGlobalState();
  var { id } = useParams();
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();

  useEffect(() => {
    openModal({ ...modalState, libraryId: id });
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {};
  }, []);

  return (
    <MasterTable
      getTableData={getLibraryBooks}
      tab1={"Library"}
      tab2={"Books"}
      libraryId={id}
      updateStatus={updateLibraryBookStatus}
      AddForm={AddLibraryBookForm}
      deleteRow={deleteLibraryBook}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default LibraryBookTable;

